import Vue from 'vue'

export const EventBus = new Vue()

export enum EventBusEvents {
  WaveformPlaying = 'waveform playing',
  GlobalWaveformStart = 'global waveform start',
  GlobalWaveformPlay = 'global waveform play',
  GlobalWaveformClose = 'global waveform close'
}
